/* eslint-disable */
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';

const FpTooltipContext = createContext(null);

function positionTooltip(clientX, clientY, width, height) {
    const margin = 12;
    let x = clientX + 14;
    let y = clientY + 14;
    if (x + width > window.innerWidth - margin) {
        x = Math.max(margin, window.innerWidth - width - margin);
    }
    if (y + height > window.innerHeight - margin) {
        y = Math.max(margin, window.innerHeight - height - margin);
    }
    return { x, y };
}

export function FpFieldTooltipProvider({ children }) {
    const [tip, setTip] = useState(null);

    const show = useCallback((payload, event) => {
        if (!payload?.title) return;
        const { x, y } = positionTooltip(event.clientX, event.clientY, 280, 120);
        setTip({ ...payload, x, y });
    }, []);

    const move = useCallback((event) => {
        setTip((prev) => {
            if (!prev) return prev;
            const { x, y } = positionTooltip(event.clientX, event.clientY, 280, 120);
            return { ...prev, x, y };
        });
    }, []);

    const hide = useCallback(() => setTip(null), []);

    const value = useMemo(() => ({ show, move, hide }), [show, move, hide]);

    return (
        <FpTooltipContext.Provider value={value}>
            {children}
            {tip && createPortal(
                <div
                    className="fp-global-tooltip"
                    style={{ left: tip.x, top: tip.y }}
                    role="tooltip"
                >
                    <div className="fp-global-tooltip-hdr">
                        <span className="fp-global-tooltip-title">{tip.title}</span>
                    </div>
                    <div className="fp-global-tooltip-body">
                        <p>{tip.desc}</p>
                        {tip.policyKey ? (
                            <code className="fp-global-tooltip-key">{tip.policyKey}</code>
                        ) : null}
                    </div>
                </div>,
                document.body,
            )}
        </FpTooltipContext.Provider>
    );
}

export function useFpFieldTooltip() {
    return useContext(FpTooltipContext);
}

export function FpFieldInfoTrigger({ fieldTip, ariaLabel }) {
    const ctx = useFpFieldTooltip();
    if (!fieldTip || !ctx) return null;

    const { show, move, hide } = ctx;

    return (
        <span
            className="fp-info-trigger"
            role="button"
            tabIndex={0}
            aria-label={ariaLabel || fieldTip.title}
            onMouseEnter={(e) => show(fieldTip, e)}
            onMouseMove={(e) => move(e)}
            onMouseLeave={hide}
            onFocus={(e) => show(fieldTip, e)}
            onBlur={hide}
        >
            <span className="fp-info-trigger__icon" aria-hidden />
        </span>
    );
}
